import { FC } from 'react'
import { SvgProps } from './svgProps'

const ShortsIcon: FC<SvgProps> = ({ width, height, color }) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={width || 32}
    height={height || 32}
    viewBox="0 0 32 32"
  >
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="1.1852"
      stroke={color || '#000'}
      d="M15.010 10.133c0.77 0 1.396-0.821 1.396-1.834v-4.613"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="1.1852"
      stroke={color || '#000'}
      d="M12.24 28.062l3.799-15.357 3.799 15.357 9.653-1.239-5.564-23.259h-15.775l-5.529 23.262 9.618 1.236z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="1.1852"
      stroke={color || '#000'}
      d="M8.151 0.593h15.76v2.972h-15.76v-2.972z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="1.1852"
      stroke={color || '#000'}
      d="M10.91 3.556c0.803 1.236 0.717 2.981-0.329 4.326-0.73 0.966-1.876 1.584-3.167 1.584-0.205 0-0.407-0.016-0.603-0.046l0.022 0.003"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="1.1852"
      stroke={color || '#000'}
      d="M21.156 3.556c-0.803 1.244-0.711 2.99 0.329 4.335 0.729 0.966 1.875 1.584 3.166 1.584 0.206 0 0.407-0.016 0.605-0.046l-0.022 0.003"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="1.1852"
      stroke={color || '#000'}
      d="M11.446 0.593v2.972"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="1.1852"
      stroke={color || '#000'}
      d="M20.616 0.593v2.972"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="1.1852"
      stroke={color || '#000'}
      d="M12.11 31.342l-11.221-1.443 0.862-3.182 11.221 1.44-0.862 3.185z"
    ></path>
    <path
      fill="none"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeMiterlimit="4"
      strokeWidth="1.1852"
      stroke={color || '#000'}
      d="M19.967 31.342l11.221-1.443-0.862-3.182-11.221 1.44 0.862 3.185z"
    ></path>
  </svg>
)

export default ShortsIcon
